module.exports = __webpack_public_path__ + "media/images/shared/suppliers/EBS-70a791101c44e2bde6ba6cb794b97e3b.jpg";